module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addcourse addcourseware coursewareModle commonAddcourse manageMeeting"
  }, [_c('div', {
    staticClass: "crumbs"
  }, [_c('span', [_vm._v("首页")]), _vm._v(">\n    "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ManageMeeting'
      }
    }
  }, [_vm._v("专题读片")])], 1), _vm._v(" >\n    "), (_vm.cutOut === 'Modify') ? _c('span', [_vm._v("修改会议")]) : _c('span', [_vm._v("新建会议")])]), _vm._v(" "), _c('div', {
    staticClass: "search medicalNews medical"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "会议名称:",
      "prop": "ConfName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入会议名称"
    },
    model: {
      value: (_vm.form.ConfName),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConfName", $$v)
      },
      expression: "form.ConfName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "会议时间:",
      "prop": "startDateStr"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "title": _vm.form.startDateStr,
      "format": "yyyy-MM-dd HH:mm",
      "type": "datetime",
      "placeholder": "选择时间"
    },
    on: {
      "change": _vm._dateChange
    },
    model: {
      value: (_vm.form.startDateStr),
      callback: function($$v) {
        _vm.$set(_vm.form, "startDateStr", $$v)
      },
      expression: "form.startDateStr"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "预计用时:",
      "prop": "ExpectTime"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.ExpectTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "ExpectTime", $$v)
      },
      expression: "form.ExpectTime"
    }
  }, _vm._l((_vm.ExpectTimes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "主持人:",
      "prop": "confChairName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.confChairName),
      callback: function($$v) {
        _vm.$set(_vm.form, "confChairName", $$v)
      },
      expression: "form.confChairName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "会议地址:",
      "prop": "confAddress"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 10,
      "placeholder": "请输入地址"
    },
    model: {
      value: (_vm.form.confAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "confAddress", $$v)
      },
      expression: "form.confAddress"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "会议类型",
      "prop": "confPrivacy"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm._radioSelect
    },
    model: {
      value: (_vm.form.confPrivacy),
      callback: function($$v) {
        _vm.$set(_vm.form, "confPrivacy", $$v)
      },
      expression: "form.confPrivacy"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "公开"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "setPassword",
    attrs: {
      "type": "confPwd",
      "placeholder": "可设置密码，6位数字",
      "maxlength": "6"
    },
    model: {
      value: (_vm.form.confPwd),
      callback: function($$v) {
        _vm.$set(_vm.form, "confPwd", $$v)
      },
      expression: "form.confPwd"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "私密"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scopeShow),
      expression: "scopeShow"
    }],
    attrs: {
      "span": 13
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "参会人员  :"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入参会人员"
    },
    on: {
      "focus": _vm._openScope
    },
    model: {
      value: (_vm.openMember),
      callback: function($$v) {
        _vm.openMember = $$v
      },
      expression: "openMember"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "addCourse"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addBtn),
      expression: "addBtn"
    }],
    staticClass: "addBtn",
    on: {
      "click": _vm._addBtn
    }
  }, [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-text"
  }, [_c('i', {
    staticClass: "arrow_first"
  }, [_vm._v(">")]), _vm._v(" "), _c('i', {
    staticClass: "arrow_second"
  }, [_vm._v(">")]), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName1),
      callback: function($$v) {
        _vm.activeName1 = $$v
      },
      expression: "activeName1"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "1.选择相关影像",
      "name": "first"
    }
  }, [_c('p-table', {
    attrs: {
      "operationWidth": _vm.operationWidth,
      "head": _vm.head,
      "data": _vm.data,
      "operation": _vm.operation,
      "height": _vm.height1
    },
    on: {
      "_operation": _vm._operation_
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "2.选择相关病例",
      "name": "second"
    }
  }, [_c('p-table', {
    attrs: {
      "head": _vm.headVal,
      "data": _vm.dataVal,
      "operation": _vm.operation2,
      "height": _vm.height1
    },
    on: {
      "_operation": _vm._operation2_
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "3.上传其他附件",
      "name": "third"
    }
  }, [_c('upload', {
    attrs: {
      "updateFileList": _vm.updateFileList,
      "updatePicList": _vm.updatePicList
    },
    on: {
      "fileChange": _vm.fileChange,
      "fileRemove": _vm.fileRemove
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    staticClass: "save-hair",
    on: {
      "click": function($event) {
        return _vm.saveConfInfo('form')
      }
    }
  }, [_vm._v("保存待发")]), _vm._v(" "), _c('el-button', {
    staticClass: "saving",
    on: {
      "click": function($event) {
        return _vm.sendConfInfo('form')
      }
    }
  }, [_vm._v("发送")])], 1), _vm._v(" "), (_vm.confConflictPop) ? _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.confConflictPop,
      "title": '会议冲突提醒',
      "width": '60%'
    },
    on: {
      "closePop": _vm.closeconfConflict
    }
  }, [_c('reportTable', {
    attrs: {
      "data": _vm.hisdata,
      "head": _vm.hisConfhead,
      "height": _vm.hisheight,
      "operationWidth": '130'
    },
    on: {
      "showDetial": _vm.hisshowDetials
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    staticClass: "save",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("继续发送")]), _vm._v(" "), _c('el-button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hospitalPop) ? _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.hospitalPop,
      "title": '从本院影像中选择',
      "width": '980px'
    },
    on: {
      "closePop": _vm.closeHospit
    }
  }, [_c('pImage', {
    attrs: {
      "studyList": _vm.studyList
    },
    on: {
      "_popshow": _vm.receiveVal,
      "_popClose": _vm.receiveClose
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('openFlagPop', {
    ref: "getFlag",
    on: {
      "openMemberVal": _vm.openMemberVal,
      "openMemberData": _vm.openMemberData
    }
  }), _vm._v(" "), (_vm.popCase) ? _c('pops', {
    attrs: {
      "show": _vm.popCase,
      "title": '从病例库中选择',
      "width": '73%'
    },
    on: {
      "closePop": _vm.closePopCase
    }
  }, [_c('div', {
    staticClass: "popScore popCourse queryCourse"
  }, [_c('div', {
    staticClass: "popContent"
  }, [_c('div', {
    staticClass: "leftCont medicalRecord_left"
  }, [_c('div', {
    staticClass: "margin10_box medicalRecord_left"
  }, [_c('collapse-medical-record', {
    attrs: {
      "tabs": _vm.tabs,
      "personList": _vm.personList,
      "treeData": _vm.treeData,
      "titleList": _vm.titleList,
      "filterText": _vm.filterText
    },
    on: {
      "tabChange": _vm.tabChange,
      "changeColl": _vm.changeColl,
      "delPerson": _vm.delPerson,
      "personClick": _vm.personClick,
      "searchClick": _vm.searchClick,
      "addPersonList": _vm.addPersonList,
      "treeNodeClick": _vm.treeNodeClick
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rightCont"
  }, [_c('div', {
    staticClass: "rightTitle"
  }, [_c('span', {
    staticClass: "alreadyChoose"
  }, [_vm._v("当前您已选择"), _c('i', {
    staticClass: "difColor"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v("条病例")]), _vm._v(" "), _c('span', {
    staticClass: "saveInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "_input",
    attrs: {
      "placeholder": "请输入关键字搜索",
      "type": "text"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "point el-icon-search _inputTable",
    on: {
      "click": _vm.tableCaseList
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "borderCont"
  }, [_c('zTable', {
    ref: "getSelection",
    attrs: {
      "head": _vm.head3,
      "data": _vm.tableData,
      "TableData": _vm.TableData,
      "height": _vm.height
    },
    on: {
      "tableVal": _vm.tableVal,
      "ValLength": _vm.ValLength
    }
  }), _vm._v(" "), _c('page', {
    attrs: {
      "total": _vm.page.total,
      "allPage": _vm.page.allPage,
      "currentPage": _vm.page.currentPage
    },
    on: {
      "current-page": _vm.__currentPage,
      "page-size": _vm.__pageSize
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "btn-box   button-box"
  }, [_c('el-button', {
    staticClass: "save btn",
    on: {
      "click": _vm.addDataVal
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "cancel btn",
    on: {
      "click": _vm._cancelCanse
    }
  }, [_vm._v("取消")])], 1)])]) : _vm._e(), _vm._v(" "), _c('casePop', {
    ref: "getCase"
  }), _vm._v(" "), _c('aycanImages', {
    ref: "aycanImages",
    attrs: {
      "hospitalId": _vm.params_image.hospitalId,
      "studyPk": _vm.params_image.studyPk,
      "studyUid": _vm.params_image.studyUid
    }
  }), _vm._v(" "), _c('fullscreen', {
    attrs: {
      "loadingText": _vm.loadingText,
      "isFullscreen": _vm.isFullscreen
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-13b6a6b8","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/manageMeeting/addManageMeeting.vue
// module id = 528
// module chunks = 1 2 3 4 5 6 7 8